module.exports = __webpack_public_path__ + "img/Question-bg-5.fc7c7ba5.png";